import store from "../../../store"
import {
    SET_FONT_URL,
} from './font_urlReducer'

export function setFontUrl(payload: string) {
    return store.dispatch(
      SET_FONT_URL(payload)
    )
}